// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".modal-backdrop.image-gallery-modal-backdrop{z-index:50000}.image-gallery-modal{font-family:Greycliff}.image-gallery-modal .modal-body{height:50vh}.image-gallery-modal .modal-body img{height:47vh;-o-object-fit:scale-down;object-fit:scale-down;width:100%}.image-gallery-modal .modal-body .carousel-control-next,.image-gallery-modal .modal-body .carousel-control-prev{color:#31363a;font-size:28px;font-weight:700;text-decoration:none}", ""]);
// Exports
module.exports = exports;
